
export default {
  data() {
    return {
      listElementNumber: 0,
      options: [
        {
          name: 'link',
          label: 'Poveznica',
          type: 'link',
        },
      ],
    }
  },
  mounted() {
    if (this.$refs.editorList && this.$refs.editorList.items) {
      this.listElementNumber = this.$refs.editorList.items.length
    }
  },
}
